import React, { createContext, useContext } from 'react'

export type FeatureFlags = {
  enable2026Plans?: boolean
  enablePrefillData?: boolean
  enableCurrentYearStartDates?: boolean
}

interface FlagContextType {
  flags: FeatureFlags
}

export const FlagContext = createContext<FlagContextType>({
  flags: {},
})

export function useFlags () {
  return useContext(FlagContext)
}

interface FlagProviderProps {
  children: React.ReactNode | ((props: FlagContextType) => React.ReactNode)
  flags: FeatureFlags
}

export function FlagProvider ({
  children,
  flags,
}: FlagProviderProps) {
  const value = {
    flags,
  }

  return (
    <FlagContext.Provider value={value}>
      {typeof children === 'function' ? children(value) : children}
    </FlagContext.Provider>
  )
}
